import { createFileRoute } from "@tanstack/react-router";
import PreferenceCenter from "@/ui/components/email-preferences/preference-center";

/**
 * Email preference centre, reached from the unsubscribe link in outbound mail.
 * Public: the link has to work for someone who is not signed in on this device.
 */
export const Route = createFileRoute("/unsubscribe")({
  component: () => (
    <main className="flex min-h-svh items-center justify-center bg-muted/30 p-4">
      <PreferenceCenter />
    </main>
  ),
});
